import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";

import axios from "axios";

import * as icon from "../services/icon";
import * as api from "api/api";
import gangstaBet5 from "assets/images/smoker-guy-1.gif";

import { fetchProfileData } from "../redux/actions/profile";
import {
  detectMarketPlace,
  fetchWalletSuccess,
  set_claim_timer,
} from "../redux/actions/wallet";

import NamingHistory from "components/ArtWork/NamingHistory";
import TransactionHistory from "components/ArtWork/TransactionHistory";
import GangstaStats from "components/Profile/GangstaStats.component";
import { connectResponse } from "utils/connectResponse";
import InvalidGangstaModal from "components/Modals/InvalidGangstaModal";
import IndividualPageSkeleton from "components/Loader/Skeleton/IndividualPageSkeleton";
import SEO from "components/SEO";
import UpgradeSkillsModal from "components/Modals/upgradeSkillsModal";
import ApprovalModalLoader from "components/Modals/ApprovalModalLoader";
import SalePriceLoader from "components/Modals/SalePriceLoader";
import TransferNFTLoader from "components/Modals/TransferNFTLoader";
import BuyPriceLoader from "components/Modals/BuyPriceLoader";
import ClaimGBETModal from "components/Modals/ClaimGBETModal";
import SkillPriceBreakDownModal from "components/Modals/SkillPriceBreakDownModal";
import ArtViewModal from "components/Modals/ArtViewModal";
import { WALLET_TYPE } from "src/constants/walletType";
import { returnSellingPrice } from "utils/sellingPrice";
import { GoLinkExternal } from "react-icons/go";

import GangstaStatus from "components/Profile/GangstaStatus.component";
import GangstaInfo from "components/Profile/GangstaInfo.component";
import GangstaTransactionCTAs from "components/Profile/GangstaTransactionCTAs.component";
import GangstaProperties from "components/Profile/GangstaProperties.component";
import WarningFloorPrice from "components/Modals/warningFloorPrice";
import WarningTransferNFT from "components/Modals/warningTransferNFT";

import Stories from "components/stories/stories";
import AddStoryModal from "components/stories/components/modal/addStoryModal";
import CreateStoryLoader from "components/stories/components/modal/createStoryLoader";
import DeleteStoryModal from "components/stories/components/modal/deleteStoryModal";
import DeleteStoryLoader from "components/stories/components/modal/deleteStoryLoader";
import GangstaActivity from "components/Profile/GangstaActivity.component";
const dayInMilliseconds = 24 * 60 * 60 * 1000; //milliSeconds

const Profile = () => {
  const { nft_id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [nftData, setNftData] = useState({});
  const [inValidID, setInValidID] = useState(false);
  const [accumulatedGbet, setAccumulatedGbet] = useState(0);
  const [claimAccmulatedGbet, setClaimAccmulatedGbet] = useState(0);
  const [salePrice, setSalePrice] = useState(-1);
  const [totalSalePrice, setTotalSalePrice] = useState(0);
  const [toAddressFinal, setToAddressFinal] = useState("");
  const [buyingPrice, setBuyingPrice] = useState(0);
  const [buyConfirm, setBuyConfirm] = useState(false);

  const [changeNameLoading, setChangeNameLoading] = useState(false);
  const [connectLoading, setConnectLoading] = useState(false);
  const [upgradeSkillLoading, setUpgradeSkillLoading] = useState(false);
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [salePriceLoading, setSalePriceLoading] = useState(false);
  const [transferNFTLoading, setTransferNFTLoading] = useState(false);
  const [buyingPriceLoading, setBuyingPriceLoading] = useState(false);
  const [claimModalLoading, setClaimModalLoading] = useState(false);
  const [skillPriceModal, setSkillPriceModal] = useState(false);
  const [upgradeModal, setUpgradeModal] = useState(false);
  const [isSalePriceModalVisible, setIsSalePriceModalVisible] = useState(false);
  const [isTransferNFTModalVisible, setIsTransferNFTModalVisible] =
    useState(false);

  const [viewArt, setViewArt] = useState(false);
  const [breakDownPrice, setBreakDownPrice] = useState({});
  const [skill, setSkill] = useState({});

  const [createStoryLoading, setCreateStoryLoading] = useState(false);
  const [deleteStoryLoading, setDeleteStoryLoading] = useState(false);

  const [createStorySuccessResponse, setCreateStorySuccessResponse] = useState({
    status: "loading",
  });
  const [deleteStorySuccessResponse, setDeleteStorySuccessResponse] = useState({
    status: "loading",
  });
  const [claimSuccess, setClaimSuccess] = useState({ status: "loading" });
  const [approvalSuccess, setApprovalSuccess] = useState({ status: "loading" });
  const [upgradeSkillSuccess, setUpgradeSkillSuccess] = useState({
    status: "loading",
  });
  const [connectSuccess, setConnectSuccess] = useState({
    status: "loading",
  });
  const [changeNameSuccess, setChangeNameSuccess] = useState({
    status: "loading",
  });
  const [transferNFTSuccess, setTransferNFTSuccess] = useState({
    status: "loading",
  });
  const [salePriceSuccess, setSalePriceSuccess] = useState({
    status: "loading",
  });

  const [buyingPriceSuccess, setBuyingPriceSuccess] = useState({
    status: "loading",
  });

  const { data, isLoading } = useSelector((state) => state.profile);
  const address = useSelector((state) => state.wallet.walletAddress);
  const [storiesList, setStoriesList] = useState([]);
  const [featuredStoryContent, setFeaturedStory] = useState(null);

  const { walletType, walletPath, transport, claimTimer, claimTimerLoading } =
    useSelector((state) => state.wallet);
  const [fee_cut_rate, setFeeCutRate] = useState(null);

  const UpdateStories = async (page) => {
    setStoryIsLoading(true);
    const stories = await icon.get_story(nft_id, page);
    // console.log(stories);
    const totalPages = await icon.get_story_page_count(nft_id);
    const story_per_page = await icon.get_story_per_page();
    const stories_first_page = await icon.get_story(
      nft_id,
      parseInt(totalPages)
    );
    setFeaturedStory(stories_first_page[stories_first_page.length - 1]);
    // console.log(stories_first_page[0]);
    let enabledStories = [];
    if (stories.length >= 1) {
      await stories.map(async (data, index) => {
        if (data.communityDisabled == "0x0" && data.ownerDisabled == "0x0") {
          enabledStories.push(data);
        }
      });
    }
    setStoriesPaginationStates((prev) => {
      return {
        ...prev,
        totalPages: parseInt(totalPages),
        sizePerPage: parseInt(story_per_page),
      };
    });

    // console.log(storiesSortByActive);
    if (storiesSortByActive.value == "Latest to Earliest") {
      setStoriesList(enabledStories.reverse());
    }

    setStoriesList(enabledStories);
    setStoryIsLoading(false);
  };

  const [storyCost, setStoryCost] = useState(null);
  const [storyCostDeletion, setStoryCostDeletion] = useState(null);

  useEffect(() => {
    let isMounted = true;
    
    const initializeProfile = async () => {
      try {
        // console.log(parseInt(nft_id));
        if (parseInt(nft_id) <= 0 || parseInt(nft_id) >= 5556) {
          navigate(`/404`);
          return;
        }
        window.addEventListener("ICONEX_RELAY_RESPONSE", eventHandler, false);
        getGbetBalance(nft_id);
        fetchNftDetails();
        getSalePrice();
        getGbetinWallet(address);

        const cut_rate = await icon.get_tx_fee_rate();
        if (isMounted) {
          setFeeCutRate(parseInt(cut_rate) / 10 ** 18);
        }
        const floorRes = await api.getFloorPrice();
        if (isMounted) {
          setFloorPrice(floorRes.data.floor_price);
        }
        // get stories
        UpdateStories(1);
        const storyCost1 = await icon.get_story_cost("CREATION");
        const storyCost_delete = await icon.get_story_cost("DELETION");

        if (isMounted) {
          setStoryCost(parseInt(storyCost1) / 10 ** 18);
          setStoryCostDeletion(parseInt(storyCost_delete) / 10 ** 18);
        }
      } catch (error) {
        console.error('Error initializing profile:', error);
      }
    };

    initializeProfile();

    return () => {
      isMounted = false;
      window.removeEventListener("ICONEX_RELAY_RESPONSE", eventHandler);
    };
  }, []);

  const [gbetInWallet, setGbetInWallet] = useState(0);
  const [ggInWallet, setGGInWallet] = useState(0);

  const getGbetinWallet = async (address) => {
    const balance = await icon.getGbetBalanceInWallet(address);
    const balanceGG = await icon.getGGBalanceOf(address);
    setGbetInWallet(balance);
    setGGInWallet(parseInt(balanceGG, 16) / 10 ** 18);
  };

  const getGbetBalance = async (nft_id) => {
    const balance = await icon.getGbetBalance(nft_id);

    setAccumulatedGbet(balance);
  };

  const getSalePrice = async () => {
    const saleDetails = await icon.getSaleByNftId(nft_id);
    const salePrices = await returnSellingPrice(saleDetails);
    setSalePrice(salePrices);
  };

  const [last_claim_timer_state, set_last_claim_timer_state] = useState(false);

  const msToTime = (distance) => {
    var _second = 1000;
    var _minute = _second * 60;
    var _hour = _minute * 60;
    var _day = _hour * 24;

    if (distance < 0) {
      return;
    }
    var days = Math.floor(distance / _day);
    var hours = Math.floor((distance % _day) / _hour) + days * 24;
    var minutes = Math.floor((distance % _hour) / _minute);
    var seconds = Math.floor((distance % _minute) / _second);
    return `${hours < 10 ? `0${hours}` : hours}:${
      minutes < 10 ? `0${minutes}` : minutes
    }:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  const fetchNftDetails = async () => {
    set_last_claim_timer_state(false);
    const nft = await icon.getCharacterInfo(nft_id);
    if (nft === "Invalid") {
      setInValidID(true);
    } else {
      const claimTimeInMilliSeconds = parseInt(nft.lastClaim) * 0.001;
      const currentTimeInMilliSeconds = new Date().getTime();
      let noOfDaysPassed = parseInt(
        (currentTimeInMilliSeconds - claimTimeInMilliSeconds) /
          dayInMilliseconds
      );
      const nextClaimTimeInMilliSeconds =
        (noOfDaysPassed + 1) * dayInMilliseconds + claimTimeInMilliSeconds;

      dispatch(
        set_claim_timer({
          daysPassed: noOfDaysPassed,
          currentTime: currentTimeInMilliSeconds,
          nextClaim: nextClaimTimeInMilliSeconds,
          timeRemainingInMilliSeconds:
            nextClaimTimeInMilliSeconds - currentTimeInMilliSeconds,
          timeRemaining: msToTime(
            nextClaimTimeInMilliSeconds - currentTimeInMilliSeconds
          ),
        })
      );
      dispatch(fetchProfileData(nft_id));
      0;
      setNftData(nft);
      setTimeout(() => {
        set_last_claim_timer_state(true);
      }, 1000);
    }
  };

  useEffect(() => {
    // console.log(`claimTmerLoading`);
    // console.log(claimTimer);
    if (last_claim_timer_state) {
      let counterTimer = setInterval(async () => {
        // console.log("timer started!");
        let currentTimer = claimTimer;
        // console.log(currentTimer.timeRemaining);
        let currentTimeInMilliSeconds = new Date().getTime();
        currentTimer.currentTime = currentTimeInMilliSeconds;
        if (currentTimer.nextClaim - currentTimeInMilliSeconds <= 0) {
          currentTimer.daysPassed = parseInt(
            (currentTimeInMilliSeconds - currentTimer.lastCLaim) /
              dayInMilliseconds
          );
          currentTimer.nextClaim =
            (currentTimer.daysPassed + 1) * dayInMilliseconds +
            currentTimer.lastCLaim;
          currentTimer.timeRemaining = msToTime(
            currentTimer.nextClaim - currentTimeInMilliSeconds
          );
          currentTimer.timeRemainingInMilliSeconds =
            currentTimer.nextClaim - currentTimeInMilliSeconds;
        } else {
          currentTimer.timeRemaining = msToTime(
            currentTimer.nextClaim - currentTimeInMilliSeconds
          );
          currentTimer.timeRemainingInMilliSeconds =
            currentTimer.nextClaim - currentTimeInMilliSeconds;
        }

        // console.log(currentTimer.timeRemaining);
        dispatch(set_claim_timer(currentTimer));
      }, 1000);
      return () => {
        // console.log("destroying");
        clearInterval(counterTimer);
        dispatch(set_claim_timer(null));
      };
    }
  }, [last_claim_timer_state]);
  const eventHandler = async (event) => {
    const response = await connectResponse(event);
    const success = { status: "success" };
    const cancel = { status: "cancel" };
    const error = { status: "error" };

    switch (response.type) {
      case "address":
        dispatch(fetchWalletSuccess(response.data, "iconex"));
        setConnectSuccess(success);
        break;

      case "json-RPC":
        getTxResultWithTimer(response.data.result);
        // setTimeout(() => {
        //   getTx(response.data);
        // }, 4000);
        break;

      case "cancel":
        modalSucessHandler(cancel);
        break;

      case "default":
        modalSucessHandler(cancel);
        break;

      default:
        modalSucessHandler(error);
    }
  };

  const getTxResultWithTimer = (txHash) => {
    setTimeout(() => {
      getTx(txHash);
    }, 4000);
  };

  const loginWithIcon = async () => {
    icon.handleLogin();
  };

  const changeName = (newName) => {
    if (address && newName.length > 2) {
      setChangeNameLoading(true);
    } else if (!address) {
      handleLogin();
    }
  };

  const getTx = async (txHash) => {
    const res = await icon.getTransactionResult(txHash);
    // console.log(res);
    if (res.status === "pending") {
      getTxResultWithTimer(txHash);
    } else {
      // if (res.status.toUpperCase() == "SUCCESS") {
      //   await api.setActivityLog(res.tx);
      // }
      getGbetBalance(nft_id);
      getGbetinWallet(address);
      await api._syncData(nft_id);
      setTimeout(() => {
        modalSucessHandler(res);
      }, 4000);
    }
  };

  const modalSucessHandler = (res) => {
    setChangeNameSuccess(res);
    setTransferNFTSuccess(res);
    setUpgradeSkillSuccess(res);
    setApprovalSuccess(res);
    setSalePriceSuccess(res);
    setCreateStorySuccessResponse(res);
    setDeleteStorySuccessResponse(res);
    setBuyingPriceSuccess(res);
    setClaimSuccess(res);
    if (res.status == "success") {
      getGbetBalance(nft_id);
      fetchNftDetails();
      getSalePrice();
      getGbetinWallet(address);
    }
    setStoriesPaginationStates((prev) => {
      return {
        ...prev,
        currentPage: 1,
      };
    });
  };

  const handleUpgradeSkill = async ({ skills, total }) => {
    setSkillPriceModal(true);

    const response = await icon.getSkillChangeCost(nft_id, total);

    setSkill(skills);
    console.log("response", response);
    setBreakDownPrice(response);
  };

  const handleSkillUpdate = async () => {
    const payload = {
      address: address,
      param: {
        nftId: nft_id,
        skillIncMapping: skill,
      },
    };

    setUpgradeSkillSuccess({ status: "loading" });
    setUpgradeSkillLoading(true);
    const res = await icon.increaseStatusLevel(
      address,
      nft_id,
      skill,
      walletType,
      walletPath,
      transport
    );

    if (walletType == WALLET_TYPE.LEDGER) {
      if (res?.name == "TransportStatusError") {
        setUpgradeSkillSuccess({ status: "cancel" });
      } else if (res) {
        getTxResultWithTimer(res);
        //setSalePriceSucgetTxResultWithTimercess({ status: "success" });
      } else {
        setUpgradeSkillSuccess({ status: "error" });
      }
    }
  };

  const __updateSellPrice__ = async (price) => {
    setTotalSalePrice(price);
    setSalePriceSuccess({ status: "loading" });
    setSalePriceLoading(true);
    const res = await icon.changeSalesPrice(
      {
        address,
        nft_id,
        price,
      },
      walletType,
      walletPath,
      transport
    );

    if (walletType == WALLET_TYPE.LEDGER) {
      //setSalePriceSuccess({ status: "success" });
      if (res?.name == "TransportStatusError") {
        setSalePriceSuccess({ status: "cancel" });
      } else if (res) {
        getTxResultWithTimer(res);
        //setSalePriceSuccess({ status: "success" });
      } else {
        setSalePriceSuccess({ status: "error" });
      }
    }
  };

  const __handleSellGangsta__ = async (price) => {
    setTotalSalePrice(price);
    setSalePriceSuccess({ status: "loading" });
    setSalePriceLoading(true);
    const res = await icon.setSellingPrice(
      {
        address,
        nft_id,
        price,
      },
      walletType,
      walletPath,
      transport
    );

    if (walletType == WALLET_TYPE.LEDGER) {
      //setSalePriceSuccess({ status: "success" });
      if (res?.name == "TransportStatusError") {
        setSalePriceSuccess({ status: "cancel" });
      } else if (res) {
        getTxResultWithTimer(res);
        //setSalePriceSuccess({ status: "success" });
      } else {
        setSalePriceSuccess({ status: "error" });
      }
    }
  };

  const __handleTransferNFT__ = async (toAddress) => {
    setToAddressFinal(toAddress);
    setTransferNFTSuccess({ status: "loading" });
    setTransferNFTLoading(true);
    const fromAddress = address;

    const res = await icon.transferNFT(
      {
        fromAddress,
        toAddress,
        nft_id,
      },
      walletType,
      walletPath,
      transport
    );

    if (walletType == WALLET_TYPE.LEDGER) {
      if (res?.name == "TransportStatusError") {
        setTransferNFTSuccess({ status: "cancel" });
      } else if (res) {
        getTxResultWithTimer(res);
        // setTransferNFTSuccess({ status: "success" })
      } else {
        setTransferNFTSuccess({ status: "error" });
      }
    }
  };

  const handleTransferNFT = async (toAddress) => {
    setToAddressFinal(toAddress);
    settransferNFTWarning(true);
  };

  const handleSellGangsta = async (price, onSalePrice) => {
    setTotalSalePrice(price);
    const floorRes = await api.getFloorPrice();
    setFloorPrice(floorRes.data.floor_price);
    if (
      price < floorRes.data.floor_price &&
      floorRes.data.floor_price != "null"
    ) {
      setFloorPriceWarning(true);
    } else {
      if (onSalePrice >= 0) {
        __updateSellPrice__(price);
      } else {
        __handleSellGangsta__(price);
      }
    }
  };

  //handling remove listing
  const _handleRemoveFromList = async (price) => {
    setTotalSalePrice(price);
    setSalePriceSuccess({ status: "loading" });
    setSalePriceLoading(true);

    const res = await icon.removeFromListing(
      {
        address,
        nft_id,
        price,
      },
      walletType,
      walletPath,
      transport
    );

    if (walletType == WALLET_TYPE.LEDGER) {
      //setSalePriceSuccess({ status: "success" });
      if (res?.name == "TransportStatusError") {
        setSalePriceSuccess({ status: "cancel" });
      } else if (res) {
        getTxResultWithTimer(res);
        //setSalePriceSuccess({ status: "success" });
      } else {
        setSalePriceSuccess({ status: "error" });
      }
    }
  };

  // Buy price modal
  const handleBuyingGangsta = async (price) => {
    // console.log("data", data);
    setBuyingPrice(price);
    setBuyingPriceSuccess({ status: "loading" });
    setBuyingPriceLoading(true);
    const res = await icon.buyListedNft(
      {
        price: price,
        nft_id: data.token_id,
        address,
      },
      walletType,
      walletPath,
      transport
    );

    if (walletType == WALLET_TYPE.LEDGER) {
      if (res?.name == "TransportStatusError") {
        setBuyingPriceSuccess({ status: "cancel" });
      } else if (res) {
        getTxResultWithTimer(res);
        //setBuyingPriceSuccess({ status: "success" });
      } else {
        setBuyingPriceSuccess({ status: "error" });
      }
    }
  };

  // create story
  const handleCreateStory = async (content) => {
    setCreateStoryLoading(true);
    setCreateStorySuccessResponse({ status: "loading" });
    const res = await icon.create_story(
      {
        nft_id: nft_id,
        address: address,
        content: content.replace(/[&\/\\#$~%<>{}]/g, ""),
        gg_value: 25,
      },
      walletType,
      walletPath,
      transport
    );

    if (walletType == WALLET_TYPE.LEDGER) {
      if (res?.name == "TransportStatusError") {
        setCreateStorySuccessResponse({ status: "cancel" });
      } else if (res) {
        getTxResultWithTimer(res);
        //setBuyingPriceSuccess({ status: "success" });
      } else {
        setCreateStorySuccessResponse({ status: "error" });
      }
    }
  };

  const handleDeleteStory = async (story_id) => {
    setDeleteStoryLoading(true);
    setDeleteStorySuccessResponse({ status: "loading" });
    const res = await icon.delete_story(
      {
        nft_id: nft_id,
        story_id: story_id,
        address: address,
      },
      walletType,
      walletPath,
      transport
    );

    if (walletType == WALLET_TYPE.LEDGER) {
      if (res?.name == "TransportStatusError") {
        setDeleteStorySuccessResponse({ status: "cancel" });
      } else if (res) {
        getTxResultWithTimer(res);
        //setBuyingPriceSuccess({ status: "success" });
      } else {
        setDeleteStorySuccessResponse({ status: "error" });
      }
    }
  };

  const changeNameSuccessHandler = () => {
    fetchNftDetails();
  };

  function isEmpty(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }

    return true;
  }

  const handleClose = (status) => {
    setUpgradeSkillLoading(false);
    setUpgradeSkillSuccess({ status: "loading" });
    if (status == "success") fetchNftDetails();
  };

  const handleApprovalRequest = async () => {
    setApprovalSuccess({ status: "loading" });
    setApprovalLoading(true);
    const res = await icon.approveMarketPlace(
      address,
      walletType,
      walletPath,
      transport
    );

    if (WALLET_TYPE.LEDGER == walletType) {
      if (res?.name == "TransportStatusError") {
        setApprovalSuccess({ status: "cancel" });
      } else if (res) {
        getTxResultWithTimer(res);
        //setApprovalSuccess({ status: "success" });
      } else {
        setApprovalSuccess({ status: "error" });
      }
    }
  };

  const handleApproval = (status) => {
    if (status == "success") {
      if (approvalSuccess.status === "success") {
        dispatch(detectMarketPlace(address));
        setApprovalLoading(false);
        setApprovalSuccess({ status: "loading" });

        if (address === nftData.owner) {
          setIsSalePriceModalVisible(true);
        } else {
          setBuyConfirm(true);
        }
      } else {
        setApprovalLoading(false);
        setApprovalSuccess({ status: "loading" });
      }
    } else {
      setApprovalLoading(false);
      setApprovalSuccess({ status: "loading" });
    }
  };

  const handleSaleLoader = (status) => {
    setSalePriceLoading(false);
    setSalePriceSuccess({ status: "loading" });
    if (status == "sale") {
      getSalePrice();
    }
  };

  const handleTransferNFTLoader = (status) => {
    setTransferNFTLoading(false);
    setTransferNFTSuccess({ status: "loading" });
  };

  const handleBuyingLoader = (status) => {
    setBuyingPriceLoading(false);
    setBuyingPriceSuccess({ status: "loading" });

    if (status == "buy") {
      fetchNftDetails();
      getSalePrice();
    }
  };

  const handleCreateStoryLoader = () => {
    setCreateStoryLoading(false);
    setCreateStorySuccessResponse({ status: "loading" });
    setStoryContentIsConfirm(false);
    setAddStoryModal(false);
    setStoryContent("");
    UpdateStories(1);
  };

  const handleDeleteStoryLoader = () => {
    setDeleteStoryModal(false);
    setDeleteStoryLoading(false);
    setDeleteStorySuccessResponse({ status: "loading" });
    UpdateStories(1);
  };

  const claimGbet = async () => {
    setClaimSuccess({ status: "loading" });
    setClaimModalLoading(true);
    setClaimAccmulatedGbet(accumulatedGbet);
    const res = await icon.claimIndividualGbet(
      address,
      nft_id,
      walletType,
      walletPath,
      transport
    );

    if (walletType == WALLET_TYPE.LEDGER) {
      if (res?.name == "TransportStatusError") {
        setClaimSuccess({ status: "cancel" });
      } else if (res) {
        getTxResultWithTimer(res);
        //setClaimSuccess({ status: "success" });
      } else {
        setClaimSuccess({ status: "error" });
      }
    }
  };

  const handleClaimCancel = () => {
    setClaimModalLoading(false);
    setClaimSuccess({ status: "loading" });
    fetchNftDetails();
  };

  const metaData = {
    pageTitle: `${
      nftData.characterName ? `${nftData.characterName} |` : ""
    } GangstaBet: A Digital Collectible  `,
    pageDescription: featuredStoryContent
      ? featuredStoryContent.content
      : "GangstaBet is a collection of 5555 unique Gangsters & Detectives with changeable names & stats.",
    pageKeywords: nftData.characterName
      ? `${nftData.characterName}, blockchain, crypto, wallet`
      : null,
    pageImage: { src: data?.token_uri },
  };
  const [FloorPriceWarning, setFloorPriceWarning] = useState(false);
  const [transferNFTWarning, settransferNFTWarning] = useState(false);

  const [floorPrice, setFloorPrice] = useState(null);

  //stories
  const [deleteStoryModal, setDeleteStoryModal] = useState(false);
  const [deletingStoryID, setDeletingStoryID] = useState("");
  const [addStoryModal, setAddStoryModal] = useState(false);
  const [storyIsLoading, setStoryIsLoading] = useState(true);

  const [storyContent, setStoryContent] = useState("");
  const [storyContentIsConfirm, setStoryContentIsConfirm] = useState(false);
  const [storiesPaginationStates, setStoriesPaginationStates] = useState({
    totalPages: 0,
    currentPage: 1,
    sizePerPage: 0,
  });
  const [storiesSortByOptions, SetStoriesSortByOptions] = useState([
    {
      key: "Earliest to Latest",
      value: "Earliest to Latest",
    },
    {
      key: "Latest to Earliest",
      value: "Latest to Earliest",
    },
  ]);
  const [storiesSortByActive, SetStoriesSortByActive] = useState({
    key: "Earliest to Latest",
    value: "Earliest to Latest",
  });

  const storyNextPage = async () => {
    if (
      storiesPaginationStates.currentPage >= 1 &&
      storiesPaginationStates.currentPage < storiesPaginationStates.totalPages
    ) {
      const currPage = storiesPaginationStates.currentPage;
      setStoriesPaginationStates((prev) => {
        return {
          ...prev,
          currentPage: currPage + 1,
        };
      });
      UpdateStories(currPage + 1);
    }
  };

  const storyPrevPage = async () => {
    if (
      storiesPaginationStates.currentPage >= 2 &&
      storiesPaginationStates.currentPage <= storiesPaginationStates.totalPages
    ) {
      const currPage = storiesPaginationStates.currentPage;
      setStoriesPaginationStates((prev) => {
        return {
          ...prev,
          currentPage: currPage - 1,
        };
      });
      UpdateStories(currPage - 1);
    }
  };

  useEffect(() => {
    let isMounted = true;
    
    const updateStoriesSort = async () => {
      try {
        if (storiesSortByActive.key == "Earliest to Latest") {
          if (isMounted) {
            setStoriesPaginationStates((prev) => {
              return {
                ...prev,
                currentPage: 1,
              };
            });
          }
          UpdateStories(1);
        } else {
          if (isMounted) {
            setStoriesPaginationStates((prev) => {
              return {
                ...prev,
                currentPage: storiesPaginationStates.totalPages,
              };
            });
          }
          UpdateStories(storiesPaginationStates.totalPages);
        }
      } catch (error) {
        console.error('Error updating stories sort:', error);
      }
    };

    updateStoriesSort();

    return () => {
      isMounted = false;
    };
  }, [storiesSortByActive]);

  const [illustrationInfo, setIllustrationInfo] = useState({});

  // Illustration Section
  useEffect(() => {
    async function runEffect() {
      const illustrationReservation = await icon.getAllReservations(address);
      console.warn(illustrationReservation);
      // const userOwnedIllustrationsArray = [...userOwnedIllustrations];

      for await (let illustration of illustrationReservation) {
        if (illustration.minted === "0x1") {
          const token = await icon.getIllustrationTokenURI(illustration.id);
          let temp_nft_id =
            "0x" + Number(illustration.reservedNftId).toString(16);
          let nft_id_in_hex = "0x" + Number(nft_id).toString(16);
          if (token && temp_nft_id === nft_id_in_hex) {
            const { data } = await axios.get(token + ".json");
            setIllustrationInfo(data);
            break;
          }
        }
      }
    }
    runEffect();
  }, []);

  return (
    <SEO pageMetaData={metaData}>
      <div className="container g-profile">
        <div className=" individual-profile-container">
          <div className="container g-profile">
            {!isEmpty(nftData) && data.length !== 0 && !isLoading ? (
              <>
                <div className="gansgtabet-overview d-flex">
                  <div className="col left">
                    <div
                      className="gp-img"
                      onClick={() => {
                        setViewArt(true);
                      }}
                    >
                      <img
                        src={data?.token_uri}
                      />
                    </div>
                    {Object.keys(illustrationInfo).length !== 0 ? (
                      <div className="d-flex px-2">
                        <img
                          src={illustrationInfo.image}
                          width="50"
                          style={{ minHeight: "60px" }}
                        />
                        <div className="illustration-info px-2">
                          <p
                            style={{ fontSize: "16px", fontWeight: "600" }}
                            className="mt-1"
                          >
                            {illustrationInfo.name}
                          </p>
                          <p
                            className="hex"
                            onClick={() => {
                              window.open(
                                `https://craft.network/nft/gangstabet-illustration:${illustrationInfo.id}`,
                                "_blank"
                              );
                            }}
                          >
                            View Illustration <GoLinkExternal />
                          </p>
                        </div>
                      </div>
                    ) : null}

                    <div
                      className="info-phone"
                      style={{ padding: "0 12px 30px 12px" }}
                    >
                      <GangstaInfo
                        class_type={nftData?.className}
                        owned_by={nftData?.owner}
                        setViewArt={setViewArt}
                        story={false}
                        token_name={nftData?.characterName}
                        token_uri={data?.token_uri}
                        address={address}
                        gbetInWallet={gbetInWallet}
                        accumulatedGbet={accumulatedGbet}
                        data={data}
                        onSuccess={changeNameSuccessHandler}
                        changeNameLoading={changeNameLoading}
                        setChangeNameLoading={setChangeNameLoading}
                        changeNameSuccess={changeNameSuccess}
                        setChangeNameSuccess={setChangeNameSuccess}
                        connectLoading={connectLoading}
                        setConnectLoading={setConnectLoading}
                        connectSuccess={connectSuccess}
                        storiesList={storiesList}
                        featuredStoryContent={featuredStoryContent}
                        setConnectSuccess={setConnectSuccess}
                        nftData={nftData}
                        currentName={nftData?.characterName}
                        walletType={walletType}
                        walletPath={walletPath}
                        transport={transport}
                        getTxResultWithTimer={getTxResultWithTimer}
                        nftId={nft_id}
                      />
                    </div>
                    {featuredStoryContent ? (
                      <div className="grey-border featured-story profile-page-section-radius">
                        <div className="feature-text-remove">
                          {featuredStoryContent.content}
                        </div>
                        {address == nftData.owner ? (
                          <div
                            className="feature-add-story-button"
                            onClick={() => {
                              setAddStoryModal(true);
                            }}
                          >
                            {
                              <svg
                                width="20"
                                height="21"
                                viewBox="0 0 20 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.3335 10.3125H16.6668"
                                  stroke="#068385"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M10 16.9788V3.64551"
                                  stroke="#068385"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            }
                            <div>Add New Story</div>
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                    <GangstaProperties
                      className={`grey-border profile-page-section-radius`}
                      propertiesList={data?.attributes}
                      isGangster={nftData?.isGangster}
                    />
                  </div>
                  <div className="col right " style={{ marginLeft: "40px" }}>
                    <div className="info-large-screen">
                      <GangstaInfo
                        class_type={nftData?.className}
                        owned_by={nftData?.owner}
                        setViewArt={setViewArt}
                        story={false}
                        token_name={nftData?.characterName}
                        token_uri={data?.token_uri}
                        address={address}
                        gbetInWallet={gbetInWallet}
                        accumulatedGbet={accumulatedGbet}
                        data={data}
                        onSuccess={changeNameSuccessHandler}
                        changeNameLoading={changeNameLoading}
                        setChangeNameLoading={setChangeNameLoading}
                        changeNameSuccess={changeNameSuccess}
                        setChangeNameSuccess={setChangeNameSuccess}
                        connectLoading={connectLoading}
                        setConnectLoading={setConnectLoading}
                        connectSuccess={connectSuccess}
                        storiesList={storiesList}
                        featuredStoryContent={featuredStoryContent}
                        setConnectSuccess={setConnectSuccess}
                        nftData={nftData}
                        currentName={nftData?.characterName}
                        walletType={walletType}
                        walletPath={walletPath}
                        transport={transport}
                        getTxResultWithTimer={getTxResultWithTimer}
                        nftId={nft_id}
                      />
                    </div>

                    <GangstaTransactionCTAs
                      address={address}
                      data={data}
                      fee_cut_rate={fee_cut_rate}
                      _handleRemoveFromList={_handleRemoveFromList}
                      gbetInWallet={gbetInWallet}
                      changeName={changeName}
                      loginWithIcon={loginWithIcon}
                      onSuccess={changeNameSuccessHandler}
                      changeNameLoading={changeNameLoading}
                      last_claim_timer={claimTimer}
                      setChangeNameLoading={setChangeNameLoading}
                      changeNameSuccess={changeNameSuccess}
                      setChangeNameSuccess={setChangeNameSuccess}
                      connectLoading={connectLoading}
                      setConnectLoading={setConnectLoading}
                      connectSuccess={connectSuccess}
                      setConnectSuccess={setConnectSuccess}
                      handleSellGangsta={handleSellGangsta}
                      salePrice={salePrice}
                      nftData={nftData}
                      claimGbet={claimGbet}
                      handleApproval={handleApprovalRequest}
                      handleBuyingGangsta={handleBuyingGangsta}
                      buyConfirm={buyConfirm}
                      setBuyConfirm={setBuyConfirm}
                      isSalePriceModalVisible={isSalePriceModalVisible}
                      setIsSalePriceModalVisible={setIsSalePriceModalVisible}
                      isTransferNFTModalVisible={isTransferNFTModalVisible}
                      handleTransferNFT={handleTransferNFT}
                      setIsTransferNFTModalVisible={
                        setIsTransferNFTModalVisible
                      }
                      nftId={nft_id}
                      currentName={nftData?.characterName}
                      setClaimAccmulatedGbet={setClaimAccmulatedGbet}
                      walletType={walletType}
                      walletPath={walletPath}
                      transport={transport}
                      getTxResultWithTimer={getTxResultWithTimer}
                    />
                    <div className="section-stats mt-4">
                      <GangstaStatus
                        data={data?.statistics}
                        address={address}
                        gbetInWallet={gbetInWallet}
                        nftData={nftData}
                        handleUpgradeSkill={handleUpgradeSkill}
                        loginWithIcon={loginWithIcon}
                        setUpgradeSkillLoading={setUpgradeSkillLoading}
                        setUpgradeSkillSuccess={setUpgradeSkillSuccess}
                        nftId={nft_id}
                        claimAccumulatedGbet={claimAccmulatedGbet}
                        upgradeModal={upgradeModal}
                        setUpgradeModal={setUpgradeModal}
                        salePrice={salePrice}
                      />
                      <GangstaStats
                        data={data?.skills}
                        address={address}
                        nftData={nftData}
                      />
                    </div>
                  </div>
                </div>

                <div className="gangstabet-stories">
                  <Stories
                    setAddStoryModal={setAddStoryModal}
                    storiesList={storiesList}
                    setDeletingStoryID={setDeletingStoryID}
                    isLoading={storyIsLoading}
                    storiesPaginationStates={storiesPaginationStates}
                    storiesSortByOptions={storiesSortByOptions}
                    storiesSortByActive={storiesSortByActive}
                    storyNextPage={storyNextPage}
                    SetStoriesSortByActive={SetStoriesSortByActive}
                    storyPrevPage={storyPrevPage}
                    setDeleteStoryModal={setDeleteStoryModal}
                    address={address}
                    isOwner={address === nftData.owner}
                  />
                </div>
                <div className="gangstabet-activity">
                  <GangstaActivity
                    TransactionHistoryData={data?.transactions}
                    NamingHistoryData={data?.naming_history}
                  />
                </div>

                <ArtViewModal
                  isVisible={viewArt}
                  onClose={() => setViewArt(false)}
                  image={data?.token_uri}
                  name={
                    nftData.characterName
                      ? nftData.characterName
                      : `GangsterBet ${parseInt(nftData.characterLevel, 16)}`
                  }
                />
                <AddStoryModal
                  isVisible={addStoryModal}
                  handleCreateStory={handleCreateStory}
                  setStoryContent={setStoryContent}
                  storyCost={storyCost}
                  storyContent={storyContent}
                  ggInWallet={ggInWallet}
                  gbetInWallet={gbetInWallet}
                  storyContentIsConfirm={storyContentIsConfirm}
                  setStoryContentIsConfirm={setStoryContentIsConfirm}
                  onClose={() => {
                    setAddStoryModal(false);
                    setStoryContent("");
                    setStoryContentIsConfirm(false);
                  }}
                />
                <DeleteStoryModal
                  isVisible={deleteStoryModal}
                  deletingStoryID={deletingStoryID}
                  ggInWallet={ggInWallet}
                  gbetInWallet={gbetInWallet}
                  storyCostDeletion={storyCostDeletion}
                  handleDeleteStory={handleDeleteStory}
                  onClose={() => {
                    setDeleteStoryModal(false);
                  }}
                />
                <UpgradeSkillsModal
                  isVisible={upgradeSkillLoading}
                  onClick={handleClose}
                  response={upgradeSkillSuccess}
                  amount={breakDownPrice?.totalCost}
                />

                <ApprovalModalLoader
                  isVisible={approvalLoading}
                  response={approvalSuccess}
                  onClick={handleApproval}
                  event={nftData.owner == address ? "sell" : "buy"}
                />

                <SalePriceLoader
                  isVisible={salePriceLoading}
                  response={salePriceSuccess}
                  onClick={handleSaleLoader}
                  cost={totalSalePrice}
                />

                <TransferNFTLoader
                  isVisible={transferNFTLoading}
                  response={transferNFTSuccess}
                  onClick={handleTransferNFTLoader}
                  toAddressFinal={toAddressFinal}
                  currentName={nftData?.characterName}
                />

                <BuyPriceLoader
                  isVisible={buyingPriceLoading}
                  response={buyingPriceSuccess}
                  onClick={handleBuyingLoader}
                  cost={buyingPrice}
                />

                <DeleteStoryLoader
                  isVisible={deleteStoryLoading}
                  response={deleteStorySuccessResponse}
                  onClick={handleDeleteStoryLoader}
                />
                <CreateStoryLoader
                  isVisible={createStoryLoading}
                  response={createStorySuccessResponse}
                  onClick={handleCreateStoryLoader}
                />
                <ClaimGBETModal
                  isVisible={claimModalLoading}
                  response={claimSuccess}
                  onClick={handleClaimCancel}
                  totalGbet={claimAccmulatedGbet}
                />

                <WarningFloorPrice
                  isVisible={FloorPriceWarning}
                  salePrice={totalSalePrice}
                  floorPrice={floorPrice}
                  __handleSellGangsta__={__handleSellGangsta__}
                  onClose={() => {
                    setFloorPriceWarning(false);
                  }}
                />

                <WarningTransferNFT
                  isVisible={transferNFTWarning}
                  toAddressFinal={toAddressFinal}
                  currentName={nftData?.characterName}
                  salePrice={salePrice}
                  __handleTransferNFT__={__handleTransferNFT__}
                  onClose={() => {
                    settransferNFTWarning(false);
                  }}
                />

                <SkillPriceBreakDownModal
                  setUpgradeModal={setUpgradeModal}
                  isVisible={skillPriceModal}
                  onConfirm={handleSkillUpdate}
                  amount={breakDownPrice}
                  onCancel={() => setSkillPriceModal(false)}
                />
              </>
            ) : (
              <IndividualPageSkeleton />
            )}
          </div>
          <InvalidGangstaModal isVisible={inValidID} />
        </div>
      </div>
    </SEO>
  );
};

export default Profile;

Profile.propTypes = {
  image: PropTypes.any,
};

Profile.defaultProps = {
  image: gangstaBet5,
};
